<template>

  <li

    class="nav-item sidebar-admin-group"

    :class="{

      active: isGroupActive,

      'sidebar-admin-group--open': isOpen,

    }"

  >

    <button

      ref="trigger"

      type="button"

      class="nav-link sidebar-nav-link sidebar-admin-group__trigger"

      :aria-expanded="isOpen ? 'true' : 'false'"

      aria-haspopup="true"

      aria-controls="sidebar-admin-flyout"

      @click="onTriggerClick"

    >

      <i class="fa-solid fa-user-shield sidebar-nav-link__icon" aria-hidden="true"></i>

      <span class="sidebar-nav-link__label">{{ label }}</span>

    </button>

    <body-portal v-if="isOpen">

      <ul

        id="sidebar-admin-flyout"

        class="sidebar-admin-group__flyout"

        :style="menuStyle"

        role="menu"

        :aria-label="label"

      >

        <li v-for="link in links" :key="link.path" role="none">

          <router-link

            :to="link.path"

            class="sidebar-admin-group__flyout-item"

            :class="{ 'sidebar-admin-group__flyout-item--active': isPathActive(link.path) }"

            role="menuitem"

            @click.native="handleLinkClick(link)"

          >

            {{ link.name }}

          </router-link>

        </li>

      </ul>

    </body-portal>

  </li>

</template>



<script>

export default {

  name: "SidebarAdminGroup",

  props: {

    links: {

      type: Array,

      default: () => [],

    },

    label: {

      type: String,

      default: "Admin",

    },

  },

  data() {

    return {

      isOpen: false,

      menuStyle: {},

    };

  },

  computed: {

    isGroupActive() {

      return this.links.some((link) => this.isPathActive(link.path));

    },

  },

  beforeDestroy() {

    this.closeMenu();

  },

  methods: {

    isPathActive(path) {

      const normalized = String(path || "").replace(/\/$/, "") || "/";

      const current = String(this.$route?.path || "").replace(/\/$/, "") || "/";

      return current === normalized || current.startsWith(`${normalized}/`);

    },

    getFlyoutEl() {

      if (typeof document === "undefined") return null;

      return document.getElementById("sidebar-admin-flyout");

    },

    onTriggerClick(event) {

      event.preventDefault();

      event.stopPropagation();

      if (this.isOpen) {

        this.closeMenu();

        return;

      }

      this.openMenu();

    },

    openMenu() {

      this.isOpen = true;

      this.$nextTick(() => {

        this.syncMenuPosition();

        this.$nextTick(() => {

          this.syncMenuPosition();

          setTimeout(() => {

            if (this.isOpen) {

              this.attachListeners();

            }

          }, 0);

        });

      });

    },

    closeMenu() {

      if (!this.isOpen) {

        this.detachListeners();

        return;

      }

      this.isOpen = false;

      this.menuStyle = {};

      this.detachListeners();

    },

    attachListeners() {

      this.detachListeners();

      window.addEventListener("pointerdown", this.onOutsidePointerDown, true);

      window.addEventListener("keydown", this.onEscapeKey);

      window.addEventListener("resize", this.syncMenuPosition);

      window.addEventListener("scroll", this.syncMenuPosition, true);

    },

    detachListeners() {

      window.removeEventListener("pointerdown", this.onOutsidePointerDown, true);

      window.removeEventListener("keydown", this.onEscapeKey);

      window.removeEventListener("resize", this.syncMenuPosition);

      window.removeEventListener("scroll", this.syncMenuPosition, true);

    },

    onOutsidePointerDown(event) {

      if (!this.isOpen) return;

      const trigger = this.$refs.trigger;

      const flyout = this.getFlyoutEl();

      if (trigger?.contains(event.target) || flyout?.contains(event.target)) {

        return;

      }

      this.closeMenu();

    },

    onEscapeKey(event) {

      if (!this.isOpen) return;

      if (event.key !== "Escape") return;

      event.preventDefault();

      this.closeMenu();

    },

    syncMenuPosition() {

      if (!this.isOpen) return;

      const trigger = this.$refs.trigger;

      const flyout = this.getFlyoutEl();

      if (!trigger || !flyout) return;



      const rect = trigger.getBoundingClientRect();

      const flyoutHeight = flyout.offsetHeight || 0;

      const flyoutWidth = flyout.offsetWidth || 220;

      const gap = 8;

      const padding = 12;



      let left = rect.right + gap;

      let top = rect.top;



      if (left + flyoutWidth > window.innerWidth - padding) {

        left = Math.max(padding, rect.left - flyoutWidth - gap);

      }

      if (top + flyoutHeight > window.innerHeight - padding) {

        top = Math.max(padding, window.innerHeight - flyoutHeight - padding);

      }



      this.menuStyle = {

        position: "fixed",

        top: `${top}px`,

        left: `${left}px`,

        zIndex: 1060,

      };

    },

    handleLinkClick(link) {

      this.closeMenu();

      if (this.$sidebar?.displaySidebar) {

        this.$sidebar.displaySidebar(false);

      }

      const eventName = String(link?.sameRouteResetEvent || "").trim();

      if (!eventName || typeof window === "undefined") return;

      window.dispatchEvent(new CustomEvent(eventName));

    },

  },

};

</script>



<style scoped>

.sidebar-admin-group {

  list-style: none;

  position: relative;

  display: flex;

  align-items: stretch;

}



.sidebar-admin-group__trigger {

  flex: 1 1 auto;

  width: 100%;

  border: none;

  background: transparent;

  cursor: pointer;

}



.sidebar-admin-group__flyout {

  min-width: 220px;

  max-width: 280px;

  margin: 0;

  padding: 6px;

  list-style: none;

  border-radius: var(--clipr-radius-md);

  background: var(--clipr-bg-elevated);

  border: 1px solid var(--clipr-border-color);

  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.45), 0 0 0 1px rgba(168, 85, 247, 0.12);

  overflow: hidden;

}



.sidebar-admin-group__flyout-item {

  display: block;

  width: 100%;

  padding: 10px 12px;

  border-radius: var(--clipr-radius-sm);

  color: var(--clipr-text-primary);

  font-size: 0.8125rem;

  font-weight: 600;

  line-height: 1.35;

  text-decoration: none;

  transition: background 0.15s ease, color 0.15s ease;

}



.sidebar-admin-group__flyout-item:hover,

.sidebar-admin-group__flyout-item:focus-visible {

  background: var(--clipr-purple-overlay-medium);

  color: var(--clipr-text-primary);

  outline: none;

}



.sidebar-admin-group__flyout-item--active {

  background: var(--clipr-purple-overlay-medium);

  border: 1px solid var(--clipr-border-purple);

  box-shadow: 0 0 12px rgba(168, 85, 247, 0.2);

}

</style>

